if(!__webpack_require__.federation){
	__webpack_require__.federation = {
		initOptions: {"name":"inboxApp","remotes":[],"shareStrategy":"version-first"},
		chunkMatcher: function(chunkId) {return !/^([19]32|203|283|325|348|567|679|904)$/.test(chunkId)},
		rootOutputDir: "",
		bundlerRuntimeOptions: { remotes: { remoteInfos: {}, webpackRequire: __webpack_require__,idToRemoteMap: {}, chunkMapping: {},idToExternalAndNameMapping: {} } }
	};
__webpack_require__.consumesLoadingData = {}
__webpack_require__.remotesLoadingData = {}
}